import React, { useEffect, useState } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { RouteProp } from '@react-navigation/native';
import useMedicalProfile from '../../../../../hooks/api/useMedicalProfile';
import {
    ContactDetailsFormValue,
    EditContactDetailsContext,
    EditContactDetailsContextType,
    Step,
} from './EditContactDetailsContext';
import EditStep1 from './EditStep1';
import EditStep2 from './EditStep2';
import { avatarStateToAvatarChange } from '../../../../v2BaseComponents/ImagePicker/TempImagePicker';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

export type EditContactDetailsOwnProps = {};

export type EditContactDetailsProps = EditContactDetailsOwnProps;

const ProfileEditDetailsNavigator: React.FC<{
    route: RouteProp<ProfilesTabParamList, 'contact-details'>;
}> = (props) => {
    const goBack = useGoBack();
    const [activeStep, setActiveStep] = useState<Step>('step1');
    const { isLoadingProfile, profile, isUpdatingContact, updateContact } = useMedicalProfile({
        medicalProfileId: props.route.params.profileId,
        onContactDetailsUpdateSuccess: () => {
            goBack();
        },
    });
    const [contactDetails, setContactDetails] = React.useState<ContactDetailsFormValue | null>(null);

    useEffect(() => {
        setContactDetails(profile?.contactDetails ? { ...profile.contactDetails, avatar: null } : null);
    }, [profile?.contactDetails]);

    const context: EditContactDetailsContextType = {
        setStep: setActiveStep,
        // @ts-expect-error TS18047
        medicalProfileId: profile?.medicalProfileId,
        contactDetails: contactDetails!,
        onContactDetailsChange: setContactDetails,
        onComplete: ({ avatar, ...contactDetails }) => {
            updateContact({
                contactDetails: {
                    contactDetails: contactDetails,
                    avatar: avatarStateToAvatarChange(avatar),
                },
                contactDetailsId: contactDetails.contactDetailsId,
            });
        },
        isUpdating: isUpdatingContact,
    };

    return (
        <AnimateLoadedContent
            key={props.route.params.profileId}
            isLoading={isLoadingProfile || !contactDetails || isUpdatingContact}
        >
            {() => (
                <ProfileHeaderContainer profileId={props.route.params.profileId} bottomBorder omitChatButton>
                    <EditContactDetailsContext.Provider value={context}>
                        {activeStep === 'step1' ? <EditStep1 /> : <EditStep2 />}
                    </EditContactDetailsContext.Provider>
                </ProfileHeaderContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(ProfileEditDetailsNavigator);
